import type { SocialsConnected } from "./types";

// Each platform's media support and the badge shown to the user.
// "flex" -> image OR video (one at a time). Mixed image+video posts are
// retired (MB-1495), so X is plain flex like the rest.
export type MediaSupport = "image" | "video" | "flex";
export const PLATFORM_CAPABILITY: Record<string, { support: MediaSupport; badge: string }> = {
    facebook:  { support: "flex",  badge: "Images or Video" },
    instagram: { support: "flex",  badge: "Images or Video" },
    linkedin:  { support: "flex",  badge: "Images or Video" },
    twitter:   { support: "flex",  badge: "Images or Video" },
    pinterest: { support: "image", badge: "Image" },
    google:    { support: "image", badge: "Image" },
    youtube:   { support: "video", badge: "Video" },
};

export type QuickSelectType = "image" | "video";

const EMPTY_SELECTION: SocialsConnected = {
    facebook: false,
    instagram: false,
    twitter: false,
    linkedin: false,
    pinterest: false,
    google: false,
    youtube: false,
};

export function supportsQuickType(
    support: MediaSupport | undefined,
    type: QuickSelectType
): boolean {
    if (!support) return false;
    return type === "video" ? support !== "image" : support !== "video";
}

// "All video" / "All images": every CONNECTED platform that supports the type.
// A momentary preset, not a mode - it replaces the current selection once and
// normal per-card toggling continues from there (MB-1492).
export function computeQuickSelection(
    type: QuickSelectType,
    connections: ReadonlyArray<{ platform: string; connected: boolean }>
): { selection: SocialsConnected; count: number } {
    const selection: SocialsConnected = { ...EMPTY_SELECTION };
    let count = 0;
    connections.forEach(({ platform, connected }) => {
        if (!connected) return;
        if (!(platform in selection)) return;
        if (!supportsQuickType(PLATFORM_CAPABILITY[platform]?.support, type)) return;
        selection[platform as keyof SocialsConnected] = true;
        count += 1;
    });
    return { selection, count };
}
